import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Import fonts */
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
  
  :root {
    /* Colors */
    --primary: #0F62FE;
    --primary-light: #4589FF;
    --primary-dark: #0043CE;
    --accent: #5C2EFF;
    --accent-light: #7B5AFF;
    --accent-dark: #4316DB;
    --neutral-100: #FFFFFF;
    --neutral-200: #F4F4F4;
    --neutral-300: #E0E0E0;
    --neutral-400: #D0E2FF;
    --text-primary: #212121;
    --text-secondary: #4B4B4B;
    --text-tertiary: #6F6F6F;
    --success: #42BE65;
    --warning: #F1C21B;
    --error: #FA4D56;
    
    /* Gradients */
    --gradient-bg: linear-gradient(#F4F7FE, #DCEBFF);
    --gradient-primary: linear-gradient(135deg, var(--primary), var(--accent));
    --gradient-accent: linear-gradient(135deg, var(--accent), var(--primary-light));
    
    /* Shadows */
    --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);
    --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.12);
    --shadow-inner: inset 0 2px 4px rgba(0, 0, 0, 0.05);
    
    /* Border Radius */
    --radius-sm: 8px;
    --radius-md: 12px;
    --radius-lg: 16px;
    --radius-xl: 24px;
    
    /* Transitions */
    --transition-fast: 0.15s ease;
    --transition-normal: 0.25s ease;
    --transition-slow: 0.35s ease;
  }
  
  /* Reset & Base Styles */
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
    background: var(--gradient-bg);
    color: var(--text-primary);
    min-height: 100vh;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  /* Glassmorphism */
  .glass {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: var(--shadow-md);
  }
  
  /* Neumorphism */
  .neumorphic {
    background: var(--neutral-200);
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05),
                -5px -5px 10px rgba(255, 255, 255, 0.8);
  }
  
  /* Button Reset */
  button {
    border: none;
    background: none;
    font-family: inherit;
    cursor: pointer;
    outline: none;
  }
  
  /* Input Reset */
  input {
    font-family: inherit;
    outline: none;
  }
`;

export default GlobalStyles;